import tzLookup from 'tz-lookup';

/**
 * The site's IANA time zone from its pin, for the monthly credit ledger.
 * Both the designer and estimate creation derive it here, at read time, so a
 * saved policy never carries a stale or hand-typed zone.
 */
export const solarSiteTimeZone = (
  site: { lat: number; lng: number } | null | undefined,
  fallbackZone = 'America/New_York'
): { zone: string; provenance: string } => {
  if (
    site &&
    Number.isFinite(site.lat) &&
    Number.isFinite(site.lng) &&
    Math.abs(site.lat) <= 90 &&
    Math.abs(site.lng) <= 180
  ) {
    try {
      return {
        zone: tzLookup(site.lat, site.lng),
        provenance: 'Site location',
      };
    } catch {
      // Out-of-range input falls through to the account default.
    }
  }
  return {
    zone: fallbackZone,
    provenance: 'Account default; no site location',
  };
};
